/**
 * Frontend mirror of builder-service's contentPlanModelDefaults.ts.
 *
 * Frontend cannot import from builder-service runtime, so the same values
 * are duplicated here. Both files MUST stay in sync — see plan Block 4.
 */

export const CONTENT_PLAN_DEFAULT_MODEL = 'gemini-3.8-flash' as const;

export const CONTENT_PLAN_IMAGE_DEFAULT_MODEL = 'gemini-3.1-flash-image' as const;
